import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface PaymentDetailsProps {
  ccName?: string;
  ccNumber?: string;
  ccBrand?: string;
  ccCsc?: string;
  ccExpMonth?: string;
  ccExpYear?: string;
}

export const PaymentDetails = types.model({
  ccName: types.maybe(types.string),
  ccNumber: types.maybe(types.string),
  ccBrand: types.maybe(types.string),
  ccCsc: types.maybe(types.string),
  ccExpMonth: types.maybe(types.string),
  ccExpYear: types.maybe(types.string),
});

export type PaymentDetailsSnapshot = SnapshotIn<typeof PaymentDetails>;
export type PaymentDetailsInstance = Instance<typeof PaymentDetails>;
